<template>
  <div class="home max">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/lxwm_banner.png"
        alt=""
      >
    </div>
    <div class="contact_con w1200">
      <div class="contact_zb">
        <h4>天津协和万邦保险经纪有限公司（总部）</h4>
        <p>地址：天津市武清开发区福源道北侧</p>
        <p>电话：400-665-0265</p>
      </div>
      <ul class="contact_fb">
        <li
          v-for="(item,i) in content"
          :key="i"
        >
        <h4>天津协和万邦保险经纪有限公司</h4>
          <h4>{{item.fgs}}</h4>
          <p>
            <span>地址：</span>
            <span>{{item.dz}}</span>
          </p>
           <p>
            <span>电话：</span>
            <span>{{item.dh}}</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      content: [
        {
          fgs: "山东分公司",
          dz: "山东省潍坊市坊子区凤凰街39号",
          dh: "0536-62281208"
        },
        {
          fgs: "北京分公司 ",
          dz: "北京市怀柔区乔梓镇文化中心119室",
          dh: "13810174838"
        },
        {
          fgs: "天津市内分公司",
          dz: "天津市南开区白堤路186号电子科技中心604室 ",
          dh: "022-27426616"
        },
        {
          fgs: "云南分公司",
          dz: "云南省昆明市盘龙区龙泉街道办事处司家营新村124号",
          dh: "0871-65023225"
        },
        {
          fgs: "内蒙古分公司",
          dz: "内蒙古呼和浩特市新城区通道北街天府花园2号写字楼11层1111室",
          dh: "18947128648"
        },
        {
          fgs: "江苏分公司 ",
          dz: "江苏淮安市经济开发区海创空间大厦10喽1002室",
          dh: "13770603638"
        },
        {
          fgs: "青岛市南分公司",
          dz: "山东省青岛市市南区山东路16号甲（阳光泰鼎大厦）1604室",
          dh: "18661668927"
        },
        {
          fgs: "湖南分公司",
          dz: "湖南尝试市芙蓉区芙蓉中路二段144号城市之心801",
          dh: "15388987525"
        },
        {
          fgs: "安徽分公司 ",
          dz: "安徽合肥市财务文化新区蔚蓝商务港城市广场A座1103室",
          dh: "17755431266"
        },
        {
          fgs: "广东分公司 ",
          dz: "广州市越秀区天河路1号707自编A98房",
          dh: "13902626746"
        },
        {
          fgs: " 广西分公司 ",
          dz: "南宁市青秀区锦春路15号威宁大厦14层对面",
          dh: "18978813958"
        },
        {
          fgs: "宁波分公司 ",
          dz: "浙江省宁波市鄞州区泰康中路468号408室",
          dh: "13736167755"
        },
        {
          fgs: "陕西分公司",
          dz: "陕西省西安市高新区科技五路8号数字生活1幢1单元24层12401号",
          dh: "18301700645"
        },
        {
          fgs: "新疆分公司",
          dz: "新疆昌吉州昌吉市延安南路喀什干休所大门北侧55-2号（45区2丘3栋）",
          dh: "18001311298"
        },
        
        {
          fgs: "河北分公司",
          dz: "河北省邯郸市肥乡县辛安镇镇经济开发区管委会办公楼",
          dh: "010-68973668"
        },
        {
          fgs: "浙江分公司 ",
          dz: "浙江省杭州市萧山区湘湖金融小镇二期西区块16号楼1-111室",
          dh: "15802148719"
        }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.contact_con {
  padding: 60px 40px;
  background-color: #fff;
      p {
        line-height: 42px;
        color: #2e2e2e;
        font-size: 24px;
      }
  .contact_zb {
    h4 {
      font-size: 28px;
      color: #567cc3;
      line-height: 52px;
      font-weight: 600;
    }
  }
  .contact_fb {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 542px;
      background-color: #f4f4f4;
      margin-top: 32px;
      padding: 30px 20px 20px 20px;
      h4{
        line-height: 35px;
        font-size: 28px;
      }
      p{
        padding: 10px 0;
          color: #5f5f5f;
          line-height: 33px;
          span{
            display: block;
            width: 400px;
            float: left;
          }
          span:nth-child(1){
            width: 80px;
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue